import { Method } from "axios";
import { defineStore } from "pinia";
import { SubscriptionIds } from "@sazka/lotteries/js/models/subscriptions/subscription-ids";
import { AnalyticsCart } from "../analytics/analytics-cart";

export type LotteryCheckoutState =
    | "none"
    | "waiting-for-deposit"
    | "waiting-for-login"
    | "waiting-for-system"
    | "deposit-pending"
    | "waiting-for-3ds";

export const useLotteryCheckoutStore = defineStore("lottery-checkout-store", {
    state: () => ({
        subscriptionIds: null as SubscriptionIds,
        checkoutKey: null as string,
        betState: "none" as LotteryCheckoutState,
        postData: null,
        scrollPosition: null as number,
        dataForRestore: null,
        analyticsCart: null as AnalyticsCart,
        orphanedCheckoutData: {
            httpMethod: null as Method,
            url: null as string,
            cost: null as number,
            useDefaultAnalytics: null as boolean,
        },
    }),
    getters: {
        hasSubscriptionIds: (state): boolean => !!state.subscriptionIds,
    },
    persist: {
        // eslint-disable-next-line no-restricted-globals
        storage: sessionStorage,
    },
});
